import { FieldArray, useFormikContext } from 'formik';

import { Button } from '../../../cdl/Button/Button';
import { translate } from '../../../common/helpers/translate.helper';
import { IconPlus } from '../../../common/icons/cdl/Plus';
import { Table } from '../../../common/Table/Table';
import { Td } from '../../../common/Table/Td';
import { Th } from '../../../common/Table/Th';
import { Tr } from '../../../common/Table/Tr';
import type { PriceCompareFormValues } from '../types/PriceCompareFormValues';
import { createPriceCompareItem } from '../utils/createPriceCompareItem';

import { ItemsTableRow } from './ItemsTableRow';

export const ItemsTable = () => {
    const { values } = useFormikContext<PriceCompareFormValues>();

    return (
        <FieldArray name="items">
            {({ push, remove }) => (
                <Table>
                    <thead>
                        <Tr>
                            <Th width="20%">{translate('order.product')}</Th>
                            <Th width="15%">{translate('order.productgroup')}</Th>
                            <Th width="15%">{translate('order.packtype')}</Th>
                            <Th>{translate('order.unitsize')}</Th>
                            <Th width="10%">{translate('order.quantity')}</Th>
                            <Th>{translate('order.volume')}</Th>
                            <Th>{translate('order.productunit')}</Th>
                            <Th>{translate('order.tableActions')}</Th>
                        </Tr>
                    </thead>

                    <tbody>
                        {values.items.map((item, index) => (
                            <ItemsTableRow
                                key={item.id}
                                index={index}
                                onRemove={() => remove(index)}
                                showRemoveIcon={values.items.length > 1}
                            />
                        ))}
                        <Tr>
                            <Td colSpan={8}>
                                <Button
                                    type="button"
                                    LeadingIcon={IconPlus}
                                    onClick={() => push(createPriceCompareItem())}
                                >
                                    {translate('order.additem')}
                                </Button>
                            </Td>
                        </Tr>
                    </tbody>
                </Table>
            )}
        </FieldArray>
    );
};
